export default __webpack_public_path__ + "static/media/PlanYearLogo.bd4c295a.svg";